import useSWR, { mutate as globalMutate } from 'swr';

import {
	getCurrentStepData,
	getDraftExpressRequest,
	getFilteredDrafts,
} from './findSpecialistService';
import { useExpressStore } from './findSpecialistStore';

export function useGetCurrentStepData(requestId: string) {
	const { setExpressData } = useExpressStore();

	return useSWR(['getCurrentStepData', requestId], async () => {
		const result = await getCurrentStepData(requestId);
		console.log('getCurrentStepData response:', result);
		return result;
	}, {
		revalidateOnFocus: false,
		revalidateOnReconnect: false,
		dedupingInterval: 0,
		onSuccess: (data) => {
			console.log('Setting expressData with connection_code:', data?.data?.connection_code);
			setExpressData(data?.data);
		},
	});
}

export function useGetDraftExpressRequest() {
	const { setDraftExpressData } = useExpressStore();

	return useSWR(['getDraftExpressRequest'], () => getDraftExpressRequest(), {
		revalidateOnFocus: false,
		revalidateOnReconnect: false,
		dedupingInterval: 0,
		onSuccess: (data) => {
			setDraftExpressData(data?.data);
		},
	});
}

const getFilteredDraftsCacheKey = (consultationType: string) => [
	'getFilteredDrafts',
	consultationType,
];

export function refetchFilteredDrafts(consultationType: string) {
	return globalMutate(getFilteredDraftsCacheKey(consultationType));
}

export function useGetFilteredDrafts(consultationType: string) {
	const { setFilteredDrafts } = useExpressStore();

	const { data, error } = useSWR(
		getFilteredDraftsCacheKey(consultationType),
		() => getFilteredDrafts(consultationType),
		{
			revalidateOnFocus: false,
			revalidateOnReconnect: false,
			dedupingInterval: 0,
			onSuccess: (data) => {
				setFilteredDrafts(data?.data);
			},
		}
	);

	return {
		data,
		error,

		refetch: () => refetchFilteredDrafts(consultationType),
	};
}
